import { Utils } from 'choerodon-ui/dataset';
export { transformString, trimString } from 'choerodon-ui/dataset';
const toLocaleStringSupportsLocales = Utils.toLocaleStringSupportsLocales;
const getNumberFormatOptions = Utils.getNumberFormatOptions;
const toLocaleStringPolyfill = Utils.toLocaleStringPolyfill;
export { toLocaleStringSupportsLocales, getNumberFormatOptions, toLocaleStringPolyfill };
